import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../../constants/enum";
import { defaultPaymentGatewayState } from "./payment-gateway.state";
import { fetchMultiplePaymentGatewayAsync, fetchSinglePaymentGatewayAsync } from "./payment-gateway.actions";
import { IPaymentGateway } from "./payment-gateway.types";


const paymentGatewaySlice = createSlice({
    initialState: defaultPaymentGatewayState,
    name: "outlets",
    reducers: {
        clearPaymentGatewayStateSync: (state) => {
            return defaultPaymentGatewayState
        },
        clearSinglePaymentGatewaySync: (state) => {
            state.single_payment_gateway = defaultPaymentGatewayState["single_payment_gateway"]

        },
    },
    extraReducers: (builder) => {
        // ################## fetchMultiplePaymentGatewayAsync ####################
        builder.addCase(fetchMultiplePaymentGatewayAsync.pending, (state, action) => {
            state.payment_gateway_list.loading = LoadState.pending
        })
        builder.addCase(fetchMultiplePaymentGatewayAsync.fulfilled, (state, action: PayloadAction<{ data: IPaymentGateway[], count: number }>) => {
            state.payment_gateway_list.loading = LoadState.succeeded
            state.payment_gateway_list.data = action.payload.data
            state.payment_gateway_list.count = action.payload.count
            state.payment_gateway_list.error = null
        })
        builder.addCase(fetchMultiplePaymentGatewayAsync.rejected, (state, action) => {
            state.payment_gateway_list.error = action.error.message as string
        })



        // ################## fetchSinglePaymentGatewayAsync ####################
        builder.addCase(fetchSinglePaymentGatewayAsync.pending, (state, action) => {
            state.single_payment_gateway.loading = LoadState.pending
        })
        builder.addCase(fetchSinglePaymentGatewayAsync.fulfilled, (state, action) => {
            state.single_payment_gateway.loading = LoadState.succeeded
            state.single_payment_gateway.data = action.payload
            state.single_payment_gateway.error = null
        })
        builder.addCase(fetchSinglePaymentGatewayAsync.rejected, (state, action) => {
            state.single_payment_gateway.error = action.error.message as string
        })
    },
});

export const paymentGatewayReducer = paymentGatewaySlice.reducer;
export const { clearPaymentGatewayStateSync, clearSinglePaymentGatewaySync } = paymentGatewaySlice.actions;
